import Link from "next/link";

const Promise = () => {
  return (
    <div className="py-[32px] md:py-[40px] lg:py-[48px] xl:py-[56px] 2xl:py-[64px] bg-[#0F1217] mb-[50px] sm:mb-0">
      <div className="container max-w-[1400px] mx-auto px-4 xxs:px-6 sm:px-[40px]">
        <h2 className="ff_poppins font-semibold text-[22px] sm:text-[32px] md:text-[40px] lg:text-[44px] xl:text-[48px] text-center text-white leading-[1.25]">
          The Edvia <span className="italic font-medium">Promise</span>
        </h2>
        <p className="text-base sm:text-xl md:text-2xl lg:text-3xl xl:text-[32px] text-white text-center max-w-[1310px] mx-auto mt-4 md:mt-5 sm:mt-6 leading-relaxed">
          "We believe education isn't just a certificate; it's a precisely
          engineered path to global impact. Our mission is to democratize elite
          mentorship and data-driven university matching for every ambitious
          mind on earth."
        </p>
        <div className="flex items-center justify-center mt-8 sm:mt-10 md:mt-11 lg:mt-12 xl:mt-14">
          <Link
            href={"/tools/course-finder?step=qualification"}
            className="bg-primary-gradient duration-300 ease-in-out rounded-full text-white text-center text-base sm:text-lg md:text-xl lg:text-2xl font-semibold ff_poppins leading-[32px] py-2.5 xxs:py-3.5 sm:py-4 md:py-5 px-6 xxs:px-8 sm:px-[54px] whitespace-nowrap overflow-hidden shinyAnimation relative before:bg-shiny-gradient before:content-[''] before:h-[200%] before:absolute before:top-[-55%] before:z-0 before:rotate-[-80deg] before:w-[90px] before:right-[calc(100%+20px)] hover:scale-[1.05] focus:scale-[1.05]"
          >
            Let's begin your journey
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Promise;
